import classNames from 'classnames';
import styles from './Accordion.module.scss';
import React from 'react';

import { AccordionItem } from './AccordionItem';
import { Container } from 'ui/components';

export interface AccordionProps {
	className?: string;
	allowMultiple?: boolean;
	accordionTitle?: string;
	accordionItems: Models.AccordionItem[];
	variant?: string;
}

export const Accordion: React.FC<AccordionProps> = ({ className, accordionItems, accordionTitle, variant }) => {
	return (
		<Container width="Standard" className={classNames(styles.Accordion, className)} variant={variant}>
			<h2 className={styles.Accordion_title}>{accordionTitle}</h2>
			{accordionItems.map((accordionItem, index) => (
				<AccordionItem {...accordionItem} key={index} />
			))}
		</Container>
	);
};
